<table *ngIf='showTable ; else errorTextField' mat-table [dataSource]="tableData" class="details-screen-table">
  <ng-container matColumnDef="accountNumber">
    <th mat-header-cell *matHeaderCellDef> Rekeningnummer </th>
    <td mat-cell *matCellDef="let data"> {{data.accountNumber ? data.accountNumber : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="compensationLimit">
    <th mat-header-cell *matHeaderCellDef> Compensatielimiet </th>
    <td mat-cell [ngClass]="{'red': data.compensationLimit < 0}"
        *matCellDef="let data">
      {{data.compensationLimit ? (data.restrictedData ? 'Afgeschermd' : data.compensationLimit.amount | currency: getCurrency(data, 'compensationLimit'):'symbol') : '-' }}</td>
  </ng-container>

  <ng-container matColumnDef="includesBalance">
    <th mat-header-cell *matHeaderCellDef> Deelname saldo cluster </th>
    <td mat-cell *matCellDef="let data"> {{data.includesBalance ? 'Ja' : 'Nee'}} </td>
  </ng-container>

  <ng-container matColumnDef="includesCluster">
    <th mat-header-cell *matHeaderCellDef> Deelname RPK cluster </th>
    <td mat-cell *matCellDef="let data"> {{data.includesCluster ? 'Ja' : 'Nee'}} </td>
  </ng-container>

  <ng-container matColumnDef="startDate">
    <th mat-header-cell *matHeaderCellDef> Ingangsdatum </th>
    <td mat-cell *matCellDef="let data"> {{data.startDate ? data.startDate : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="actualBalance">
    <th mat-header-cell *matHeaderCellDef> Actueel saldo </th>
    <td mat-cell [ngClass]="{'red': data.actualBalance < 0}"
        *matCellDef="let data">
      {{data.actualBalance ? (data.restrictedData ? 'Afgeschermd' : data.actualBalance.amount | currency: getCurrency(data, 'actualBalance'):'symbol') : '-' }}</td>
  </ng-container>

  <ng-container matColumnDef="accountHolder">
    <th mat-header-cell *matHeaderCellDef> Tenaamstelling </th>
    <td mat-cell *matCellDef="let data"> {{data.accountHolder ? data.accountHolder : emptyValuePlaceholder}} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
</table>
<ng-template #errorTextField>
  <div class="error-text">
    {{errorText}}
  </div>
</ng-template>
